import Buildable from "../language/Buildable.js"
import HTTPResponse from "./HTTPResponse.js"
import type { HTTPResponseBody } from "./HTTPResponseBody.js"

/**
 * @description
 *	An HTTP/HTTPS response.
 */
export default class HTTPResponseBuilder<O> implements Buildable<HTTPResponse<O>> {
	public _body: O | undefined
	public _headers: Record<string, string>
	public _statusCode: number
	public _statusText: string

	public constructor() {
		this._body = undefined
		this._headers = {}
		this._statusCode = 200
		this._statusText = "OK"
	}

	public body(body: HTTPResponseBody): HTTPResponseBuilder<O> {
		/* eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment --
		 *	TODO: Apply further transformation and validation of the body.
		 */
		this._body = body as any
		return this
	}

	public build(): HTTPResponse<O> {
		return new HTTPResponse<O>(this)
	}

	public header(key: string, value: string): HTTPResponseBuilder<O> {
		this._headers = {
			...this._headers,
			[key.toLowerCase()]: value
		}
		return this
	}

	public status(code: number, text: string): HTTPResponseBuilder<O> {
		if (code < 100 || 600 <= code) {
			throw new Error(`Status code must be inside [100, 599] interval: ${code}.`)
		}
		this._statusCode = code
		this._statusText = text
		return this
	}
}
